/* eslint-disable react/jsx-curly-newline */
/* eslint-disable import/order */
/* eslint-disable max-len */
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import Stepper from "shared-components/lib/iac-stepper";
import { STEPS } from "../../Common/store/data/commonData";
import {
  selectRetrofitSizingCurrentStep,
  selectSizingDynamics,
  selectSizingGearBox,
  selectSizingMechanics,
  setCurrentSizingStep
} from "../store/slices/retrofit";

/**
 * Sub header of the app.
 */
const SizingStepper = () => {
  const steps = STEPS.RETROFIT_SIZING;
  const currentStep = useSelector(selectRetrofitSizingCurrentStep);
  const dispatch = useDispatch();

  const handleSizingResultsSettings = (step) => {
    dispatch(setCurrentSizingStep(step));
    // dispatch(updateConfiguration());
  };

  const defineMechanics = useSelector(selectSizingMechanics);
  const defineDynamics = useSelector(selectSizingDynamics);
  const gearBoxSelection = useSelector(selectSizingGearBox);

  const isDefineMechanicsValid = () => defineMechanics.isValid;
  const isDefineDynamicsValid = () => defineDynamics.isValid;
  const isGearSelectionValid = () => gearBoxSelection.isValid;

  const handleGoToDefineMechanics = () => {
    dispatch(setCurrentSizingStep(steps.DEFINE_MECHANICS));
    // dispatch(updateConfiguration());
  };

  const handleGoToDefineDynamics = () => {
    if (isDefineMechanicsValid()) {
      dispatch(setCurrentSizingStep(steps.DEFINE_DYNAMICS));
      // dispatch(updateConfiguration());
    }
  };

  const handleGoToGearBoxSelection = () => {
    if (isDefineMechanicsValid() && isDefineDynamicsValid()) {
      dispatch(setCurrentSizingStep(steps.GEARBOX_SELECTION));
      // dispatch(updateConfiguration());
    }
  };

  const sizingStepper = (
    <>
      <Stepper
        steps={[
          {
            action: () => handleGoToDefineMechanics(),
            active: true,
            done: isDefineMechanicsValid(),
            hidden: false,
            id: "DEFINE_MECHANICS",
            isActiveStep: currentStep === steps.DEFINE_MECHANICS,
            label: "Define Mechanics",
            name: "DEFINE_MECHANICS",
            order: 1,
            skipped: false
            /*  subLabel:
              currentStep === steps.DEFINE_MECHANICS
                ? t("msizer.ui.stepper.in_progress")
                : isDefineMechanicsValid()
                ? t("msizer.ui.stepper.done")
                : t("msizer.ui.stepper.not_done") */
          },
          {
            action: () => handleGoToDefineDynamics(),
            active: isDefineMechanicsValid(),
            done: isDefineDynamicsValid(),
            hidden: false,
            id: "DEFINE_DYNAMICS",
            isActiveStep: currentStep === steps.DEFINE_DYNAMICS,
            label: "Define Dynamics",
            name: "DEFINE_DYNAMICS",
            order: 2,
            skipped: false
            /* subLabel:
              currentStep === steps.DEFINE_DYNAMICS
                ? t("msizer.ui.stepper.in_progress")
                : isDefineDynamicsValid()
                ? t("msizer.ui.stepper.done")
                : t("msizer.ui.stepper.not_done") */
          },
          {
            action: () => handleGoToGearBoxSelection(),
            active: isDefineMechanicsValid() && isDefineDynamicsValid(),
            done: isGearSelectionValid(),
            hidden: false,
            id: "GEARBOX_SELECTION",
            isActiveStep: currentStep === steps.GEARBOX_SELECTION,
            label: "Gearbox Selection",
            name: "GEARBOX_SELECTION",
            order: 3,
            skipped: false
            /* subLabel:
              currentStep === steps.GEARBOX_SELECTION
                ? t("msizer.ui.stepper.in_progress")
                : isGearSelectionValid()
                ? t("msizer.ui.stepper.done")
                : t("msizer.ui.stepper.not_done") */
          },
          {
            action: () => handleSizingResultsSettings(steps.SIZING_RESULTS),
            active: isDefineMechanicsValid() && isDefineDynamicsValid() && isGearSelectionValid(),
            done: currentStep === steps.SIZING_RESULTS,
            hidden: false,
            id: "SIZING_RESULTS",
            isActiveStep: currentStep === steps.SIZING_RESULTS,
            label: "Sizing Results",
            name: "SIZING_RESULTS",
            order: 4,
            skipped: false
            /* subLabel:
              currentStep === steps.SIZING_RESULTS ? t("msizer.ui.stepper.done") : t("msizer.ui.stepper.not_done") */
          }
        ]}
        mobileBreakpoint={800}
        disabled={false}
      ></Stepper>
    </>
  );

  return sizingStepper;
};

SizingStepper.propTypes = {};

SizingStepper.defaultProps = {};

export default SizingStepper;
